module.exports = __webpack_public_path__ + "static/img/pictureSplit.59525c9c.svg";